{
  "it": {
    "upsell": {
      "categories": {
        "category": "Categoria",
        "home_automation": "Domotica",
        "integration": "Integrazione",
        "interior_decoration": "Decorazione d'interni",
        "interior_doors": "Porte interne",
        "kitchen": "Cucina",
        "marketing": "Marketing",
        "real_estate_agent": "Agente immobiliare",
        "telecom": "Telecomunicazioni",
        "wood_finishing": "Finitura del legno"
      },
      "contact_us": "Interessato? Ci contatti.",
      "decisions_partners": {
        "guidance": "I partner della decisione possono creare e/o gestire le proposte, se autorizzati.",
        "intercom": "Ciao Ziggu, sono interessato alla funzionalità Partner della decisione. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}"
      },
      "decisions_proposals_multiple_approval": {
        "cta": "Chatta con noi per saperne di più",
        "description": "Stanco di annullare l'approvazione di una proposta per aggiungere delle modifiche e ricominciare da capo? La necessità di più approvazioni non dovrebbe rallentarLa.",
        "description_2": "Permetta ai Suoi clienti di approvare più proposte all'interno della stessa decisione. Non è necessario annullare l'approvazione di una proposta esistente o avviare una nuova decisione.",
        "description_3": "Meno complicazioni e più tempo per concentrarsi su ciò che conta davvero: il Suo cliente.",
        "intercom": "Ciao Ziggu, vorrei che il cliente potesse approvare più proposte all'interno di una decisione. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}",
        "premium_add_on": "Componente aggiuntivo premium",
        "title": "Risparmi tempo con il componente aggiuntivo per le proposte flessibili"
      },
      "decisions_reminders": {
        "guidance": "I promemoria Le consentono di notificare automaticamente ai clienti che ci sono proposte in attesa di una decisione.",
        "intercom": "Ciao Ziggu, sono interessato alla funzionalità Promemoria. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}"
      },
      "financials": {
        "guidance": "Crei piani di rate direttamente dalle proposte approvate e li condivida con i Suoi clienti tramite il portale cliente.<br>Mantenga la Sua comunicazione finanziaria trasparente e professionale: i clienti hanno sempre una panoramica chiara di cosa è dovuto e quando.",
        "intercom": "Ciao Ziggu, sono interessato alla funzionalità Finanze per le rate sulle decisioni. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}"
      },
      "imInterested": "Sono interessato",
      "intercom": "Ciao Ziggu, sono interessato a saperne di più su {upsell}. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}",
      "interestedToBeListed": "Interessato a essere elencato qui",
      "lookingfor": "Cosa sta cercando? Ad es. visual 3D, cucina, telecomunicazioni",
      "not_included": "Interessato a questa funzionalità?",
      "project_email_forwarding": {
        "cta": "Inoltra le email a {project_name}",
        "description": "Consenta a chiunque nel Suo team di inoltrare le email direttamente ai Suoi progetti Ziggu.",
        "intercom": "Ciao Ziggu, sono interessato alla funzionalità di inoltro email dei progetti. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}",
        "marketplace": {
          "title": "Inoltro email dei progetti",
          "title_sub": "Inoltri le email direttamente ai Suoi progetti Ziggu."
        },
        "title": "Nuovo: inoltro email all'interno dei progetti",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Sì, potete contattarmi per questo.",
        "cta": "Migliora il branding del progetto?",
        "description": "URL e schermata di accesso personalizzati per il progetto <br/> Ambiente di progetto dedicato dopo l'accesso <br/> Email brandizzate per il progetto <br/> Rende più semplice collaborare con altri sviluppatori immobiliari sullo stesso progetto",
        "intercom": "Ciao Ziggu, sono interessato al modulo Esperienza del progetto. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}",
        "marketplace": {
          "title": "Esperienza del progetto",
          "title_sub": "Migliori il branding del Suo progetto con un URL e un ambiente personalizzati."
        },
        "title": "Faccia sentire i Suoi clienti a casa con la nuova Esperienza del progetto",
        "youtube_id": "f26cNo2rwWE"
      },
      "project_templates": {
        "cta": "Importa da un modello?",
        "cta2": "Desidera importare questo modello nei Suoi progetti? Faccia clic qui per sbloccare questa funzionalità.",
        "description": "<p>Trasformi la gestione dei progetti con modelli predefiniti che Le fanno risparmiare tempo e mantengono il Suo team sincronizzato.</p><br>\n<p><strong>Vantaggi dei modelli:</strong></p>\n<ul>\n    <li><strong>- Risparmi ore</strong> di lavoro su attività ripetitive, importando interi framework di progetto in pochi secondi.</li>\n    <li><strong>- Standardizzazione migliorata</strong> avendo tutto in un unico posto, dalle attività ai documenti.</li>\n    <li><strong>- Maggiore efficienza</strong> automatizzando i processi di routine, così può concentrarsi su ciò che conta davvero.</li>\n</ul>\n<br/><strong>Aggiorni oggi stesso e ottenga di più con meno sforzo.</strong>",
        "intercom": "Ciao Ziggu, sono interessato alla funzionalità dei modelli. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}",
        "marketplace": {
          "title": "Modelli",
          "title_sub": "Trasformi la gestione dei progetti con modelli predefiniti che Le fanno risparmiare tempo e mantengono il Suo team sincronizzato."
        },
        "title": "Lavori in modo più intelligente con i modelli"
      },
      "proposal_choice_lists": {
        "guidance": "Gli elenchi di opzioni Le permettono di consentire ai clienti di effettuare scelte all'interno delle proposte.",
        "intercom": "Ciao Ziggu, sono interessato alla funzionalità Elenchi di opzioni. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}"
      },
      "signatures": {
        "cta_text": "Ha bisogno di firme per i Suoi documenti? Ci contatti",
        "guidance": "Le firme Le permettono di far firmare digitalmente ai clienti documenti importanti.",
        "intercom": "Ciao Ziggu, sono interessato alla funzionalità Firme. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}"
      },
      "workflows": {
        "attach_body": "Suggerimento: anche decisioni e questionari possono essere collegati a una fase. Vengono poi pubblicati automaticamente non appena la fase viene raggiunta.",
        "cta": "Scopri di più",
        "cta_sent": "La contatteremo",
        "dismiss": "Non ora",
        "intercom": "Vorrei saperne di più su cosa aggiungono i workflow alle fasi.",
        "move_hint_phases": "Suggerimento: una fase può pubblicare da sola le proprie decisioni, i questionari e le attività non appena viene raggiunta.",
        "move_hint_tasks": "Suggerimento: una fase può anche pubblicare da sola le proprie decisioni e i questionari non appena viene raggiunta."
      },
      "workflows_elements": {
        "guidance": "Il Suo piano attuale non include questo tipo di elemento. Resta nella fase, ma i clienti non lo riceveranno finché non effettua l'upgrade.",
        "intercom": "Ciao Ziggu, sono interessato a condividere decisioni, questionari e attività tramite le fasi. Potete fornirmi maggiori informazioni? Cordiali saluti, %{name}"
      }
    }
  }
}
